import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { testimonials } from '../../data/content';
export function Testimonials() {
  return <section className="bg-sand px-5 py-16 sm:py-24" data-id="element-330" data-mp="3mf7pufvy5mbi">
      <div className="mx-auto max-w-5xl" data-id="element-331" data-mp="3r7905w9k12yw">
        <SectionHeading eyebrow="What our customers say" title={<>
              Real experiences from people who <em className="text-brand-700" data-id="element-333" data-mp="42t1z924inng">used the protocol</em>
            </>} data-id="element-332" data-mp="3r93kb8d04r1x" />
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-334" data-mp="91w86wtuazx0">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 sm:p-7" data-id="element-335" data-mp="e0z2pnc71nqq">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-336" data-mp="dymmpfpzxngb">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-337" data-mp="2ftewkerxbo02" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[17px] leading-relaxed text-ink" data-id="element-338" data-mp="1slu6q8nfk1ah">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-brand-100 pt-5" data-id="element-339" data-mp="1nrpxtjultj6r">
                <img src={t.photo} alt={t.name} className="h-14 w-14 rounded-full object-cover ring-2 ring-brand-100" loading="lazy" data-id="element-340" data-mp="1isn5mzzq37g7" />
                <div data-id="element-341" data-mp="2bjx1l42nssg7">
                  <p className="font-bold text-ink" data-id="element-342" data-mp="2bic87hs2zfjx">{t.name}</p>
                  <p className="text-sm text-ink-soft" data-id="element-343" data-mp="26kalmmvg4y3p">{t.country}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>
        <CtaButton label="I want to be next" className="mt-12" data-id="element-344" data-mp="22gvvv4hph3d2" />
      </div>
    </section>;
}